<script lang="ts">
	export let className: string = '';
</script>

<div class="flex border-none rounded w-full font-light text-gray-900 {className}">
	<slot />
</div>
